<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.quote.special_order_title' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>
<div class="modal-subtitle-container">
    {{ 'bikeshop.workshop.jobcard.quote.special_order_subtitle_link' | translate }}
</div>
<div class="modal-content-container">
    <div class="quote-container">
        <div class="quote-selection-header">
            <div class="selection">
                <hub-checkbox [(ngModel)]="globalSelected" (change)="globalSelection($event)"></hub-checkbox>
            </div>
            <div>{{ (getSelectedCount() === 1 ? 'bikeshop.workshop.jobcard.quote.special_order_single_item_selected' : 'bikeshop.workshop.jobcard.quote.special_order_multiple_items_selected') | translate : { count: getSelectedCount() } }}</div>
        </div>
        <div class="quote-line-items-container">
            <div class="quote-line-item" *ngFor="let lineItem of lineItems"
                [ngClass]="{'archived-product': lineItem.FoundInPOS === false}">

                <div class="selection"><hub-checkbox [(ngModel)]="lineItem.selected" [disabled]="lineItem.SpecialOrderStatus !== null"></hub-checkbox></div>
                <div class="quote-line-quantity">
                    {{ lineItem.Quantity }}x
                </div>
                <div class="quote-line-name">
                    <div>{{ lineItem.Name }}</div>
                    <div>{{ lineItem.SKU }}
                        <span *ngIf="lineItem.StockOnHand && lineItem.StockOnHand > 0"> | {{lineItem.StockOnHand}}
                            {{'bikeshop.modal.update_job_card.quote.qty' | translate}}</span>
                        <span *ngIf="lineItem.OutOfStock && lineItem.SpecialOrderStatus === null" class="out-of-stock">
                            {{'bikeshop.workshop.jobcard.quote.no_stock' | translate}}</span>
                        <!-- {{lineItem.ID || 'N/A'}} {{lineItem.InternalProductID}} {{lineItem.SKU}} -->
                    </div>
                </div>
                <div class="quote-line-price">
                    <div>{{ (vatInclusive ? lineItem.UnitPrice_IncludingTax : lineItem.UnitPrice) | currency:
                        currencySymbol}}</div>
                    <div *ngIf="lineItem.Discount && lineItem.Discount > 0" class="discount-lineitem">
                        -{{((jobcard.quote.couponDiscountType === 'PERCENT' ? lineItem.Quantity : 1 ) *
                        lineItem.Discount).toFixed(2) | currency: currencySymbol}}
                        <!-- <span
                                *ngIf="lineItem.DiscountID > 0 && getLSDiscountPercentage(lineItem.DiscountID)">({{getLSDiscountPercentage(lineItem.DiscountID)}}%)</span> -->
                    </div>
                </div>

            </div>
        </div>
    </div>

</div>
<div class="modal-footer-container">
    <div class="button-container">

        <hub-button [text]="'general.continue' | translate" [style]="'secondary'" [disabled]="getSelectedCount() === 0 || sendingToPOS" [loading]="sendingToPOS"
            [size]="'xl'" (buttonClick)="createSpecialOrder()"></hub-button>
    </div>
</div>